import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { IUIConfiguration } from "../model"
import { UiConfigFileUpload } from "./UiConfigFileUpload"

interface IUiConfigFilesUploadProps {
  uiConfig: IUIConfiguration
}

export const UiConfigFilesUpload = React.memo(({ uiConfig }: IUiConfigFilesUploadProps) => (
  <FlexBox gap="3rem" wrap>
    <UiConfigFileUpload
      params={{
        title: "Favicon",
        imageKey: "favicon",
        imageHeightInRem: 2,
        imageWidthInRem: 2
      }}
      uiConfig={uiConfig}
    />
    <UiConfigFileUpload
      params={{
        title: translate("admin.ui-configuration.image.logo.big"),
        imageKey: "logoBig",
        imageHeightInRem: 5,
        imageWidthInRem: 16
      }}
      uiConfig={uiConfig}
    />
    <UiConfigFileUpload
      params={{
        title: translate("admin.ui-configuration.image.logo.small"),
        imageKey: "logoSmall",
        imageHeightInRem: 4,
        imageWidthInRem: 4
      }}
      uiConfig={uiConfig}
    />
    <UiConfigFileUpload
      params={{
        title: translate("admin.ui-configuration.image.login"),
        imageKey: "login",
        imageHeightInRem: 18,
        imageWidthInRem: 32
      }}
      uiConfig={uiConfig}
      isOptional
    />
  </FlexBox>
))
